let storage = {
  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  get(key) {
    return JSON.parse(localStorage.getItem(key));
  },
  remove(key) {
    localStorage.removeItem(key)
  }

}
export default storage;

//    "sass-loader": "^8.0.2",
//    "node-sass": "^4.14.1"



// WEBPACK FOOTER //
// ./src/api/storage.js